"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbUSDSession = void 0;
const events_1 = require("../../../features/events");
const cc_1 = require("../cc");
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
class MbUSDSession extends cc_1.MbCCSession {
    constructor(sessionStorage, urlConfig, eventBus) {
        super(sessionStorage, eventBus);
        this.isDataValid = (data) => {
            if (data.entrypoint === cc_1.EntrypointType.USD && data.accessToken && data.agentToken) {
                return true;
            }
            return false;
        };
        this.getHeaders = () => {
            var _a;
            const data = this.getData();
            return {
                accessToken: (_a = data === null || data === void 0 ? void 0 : data.agentToken) !== null && _a !== void 0 ? _a : '',
            };
        };
        this.doRefresh = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const actualSessionInfo = {
                    refreshToken: (_a = this.getData()) === null || _a === void 0 ? void 0 : _a.refreshToken,
                    username: (_b = this.getData()) === null || _b === void 0 ? void 0 : _b.username,
                };
                const headers = this.getHeaders();
                const { data: { accessToken, sessionExpiresAt, expiresIn, refreshToken }, } = yield this.xhr.POST(this.urlConfig.refreshToken, actualSessionInfo, { headers });
                const newSessionData = Object.assign(Object.assign({}, this.getData()), { accessToken, sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null, expiresIn, refreshToken: refreshToken !== null && refreshToken !== void 0 ? refreshToken : actualSessionInfo.refreshToken, username: (_d = (_c = this.getData()) === null || _c === void 0 ? void 0 : _c.username) !== null && _d !== void 0 ? _d : '', timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn) });
                (0, events_1.publishRefreshedSessionEvent)(newSessionData, this.eventBus);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.doAgentRefresh = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const agentToken = yield ((_a = this.usd) === null || _a === void 0 ? void 0 : _a.getMethods().getAgentAccessToken());
                const newSessionData = Object.assign(Object.assign({}, this.getData()), { agentToken: agentToken });
                (0, events_1.publishRefreshedSessionEvent)(newSessionData, this.eventBus);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.urlConfig = urlConfig;
    }
}
exports.MbUSDSession = MbUSDSession;
//# sourceMappingURL=index.js.map